import React from "react";
import { PieChart, Pie, Cell, Tooltip, ResponsiveContainer } from "recharts";
import { Panel, ChartTooltipStyle } from "./ui";

const Donut = ({ data }) => {
  const total = data.reduce((s, d) => s + d.value, 0);
  return (
    <div className="flex flex-col items-center">
      <div className="h-40 w-40 relative">
        <ResponsiveContainer width="100%" height="100%">
          <PieChart>
            <Pie data={data} dataKey="value" nameKey="name" innerRadius="62%" outerRadius="95%" paddingAngle={2} strokeWidth={0}>
              {data.map((d) => <Cell key={d.name} fill={d.color} />)}
            </Pie>
            <Tooltip contentStyle={ChartTooltipStyle} formatter={(val, name) => [`${val} (${Math.round((val / total) * 100)}%)`, name]} />
          </PieChart>
        </ResponsiveContainer>
        <div className="absolute inset-0 flex flex-col items-center justify-center pointer-events-none">
          <span className="text-lg font-extrabold text-gray-900">{total}</span>
          <span className="text-[10px] text-gray-400 font-semibold">סה״כ</span>
        </div>
      </div>
      <ul className="mt-3 grid grid-cols-1 gap-1 w-full">
        {data.map((d) => (
          <li key={d.name} className="flex items-center justify-between text-[11px] text-gray-600">
            <span className="flex items-center gap-1.5 truncate">
              <span className="w-2 h-2 rounded-full flex-shrink-0" style={{ background: d.color }} />
              {d.name}
            </span>
            <span className="font-bold text-gray-800">{d.value}</span>
          </li>
        ))}
      </ul>
    </div>
  );
};

const StatusDistributionChart = ({ requestData, lessonData, loading, error, onRetry }) => (
  <Panel
    eyebrow="סטטוסים"
    title="התפלגות בקשות ושיעורים"
    subtitle="לפי סטטוס נוכחי"
    accent="rose"
    loading={loading}
    error={error}
    onRetry={onRetry}
    empty={!loading && !error && (!requestData?.length && !lessonData?.length)}
  >
    <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
      <div>
        <p className="text-[11px] font-bold text-gray-500 text-center mb-1">בקשות שיעור פרטי</p>
        <Donut data={requestData} />
      </div>
      <div>
        <p className="text-[11px] font-bold text-gray-500 text-center mb-1">סטטוס שיעורים</p>
        <Donut data={lessonData} />
      </div>
    </div>
  </Panel>
);

export default StatusDistributionChart;
